import { FormTextCollection } from './FormTextCollection'

export const FormTextCollectionFillablePdf = (props) => {
  return <FormTextCollection {...props} pdf />
}
